import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://gjdnxnmzdpichfgtvbpg.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdqZG54bm16ZHBpY2hmZ3R2YnBnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODExOTYyMDAsImV4cCI6MjA5Njc3MjIwMH0.mzg1tbfC3FTcQyQazsd4flmcehiCaydMBkdX18jmkps";

// Capture auth tokens BEFORE Supabase clears the hash on createClient
const _hash = window.location.hash;
if (_hash) {
  const _p = new URLSearchParams(_hash.replace(/^#/, ""));
  const _type = _p.get("type");
  if (_type === "recovery") {
    sessionStorage.setItem("portal_pending_recovery", "1");
  }
  if (_type === "invite" || _type === "signup") {
    const _at = _p.get("access_token");
    const _rt = _p.get("refresh_token") || "";
    if (_at) {
      sessionStorage.setItem("portal_pending_invite", JSON.stringify({ at: _at, rt: _rt, type: _type }));
    }
  }
  if (_p.get("error_code") === "otp_expired" || _p.get("error") === "access_denied") {
    sessionStorage.setItem("portal_link_expired", "1");
  }
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: { persistSession: true, storageKey: 'taxshop-auth', storage: window.sessionStorage },
});
